import { DropdownMenuItem, DropdownMenuLabel } from '@/components/ui/dropdown-menu';
import { CloudDownloadIcon, GraduationCapIcon, LogOutIcon, UserIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

interface Props {
  pathname: string;
  openDialog: (type: string) => void;
}

export function BudgetSwitcherDashboard({ openDialog, pathname }: Props) {
  return (
    <>
      <DropdownMenuLabel className="text-xs text-muted-foreground"> Dashboard</DropdownMenuLabel>
      <DropdownMenuItem asChild disabled={pathname === '/dashboard/account-settings'}>
        <Link to="/dashboard/account-settings" className="flex items-center gap-2">
          <div className="flex size-6 items-center justify-center">
            <UserIcon className="size-4 shrink-0" />
          </div>
          Account Settings
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem asChild disabled={pathname === '/dashboard/bank-integration'}>
        <Link to="/dashboard/bank-integration" className="flex items-center gap-2">
          <div className="flex size-6 items-center justify-center">
            <CloudDownloadIcon className="size-4 shrink-0" />
          </div>
          Bank Integration
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem asChild disabled={pathname === '/dashboard/tutorial'}>
        <Link to="/dashboard/tutorial" className="flex items-center gap-2">
          <div className="flex size-6 items-center justify-center">
            <GraduationCapIcon className="size-4 shrink-0" />
          </div>
          Tutorial
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem className="gap-2" onClick={() => openDialog('logout')}>
        <div className="flex size-6 items-center justify-center  ">
          <LogOutIcon className="size-4 shrink-0 " />
        </div>
        Logout
      </DropdownMenuItem>
    </>
  );
}
